import { fromFetch } from 'rxjs/fetch';

import { AuthHeaders } from '../../../models/auth-headers';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectBlob } from '../../../utils/select-blob';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';

/**
 * Get all Users as a CSV file
 * @returns CSV data as Blob
 */
export function getUsersCsvfile(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(`${accountsEnvironment.resolve(this).usersUrl}/csvfile`, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
            ? new AuthHeaders()
            : jwtAuthHeaders),
        },
      })
    )
  ).pipe(selectBlob());
}
